export default {
    manage_deleteLocation_title: "Eliminar ubicación",
    manage_deleteLocations_title: "Eliminar ubicaciones",
    manage_deleteLocations_description: "¿Estás seguro de que quieres eliminar las ubicaciones?",
    manage_deleteLocation_description: "¿Estás seguro de que quieres eliminar esta ubicación?",
    manage_deleteLocation_successMessage: "Ubicación eliminada",
    manage_deleteLocations_successMessage: "Ubicaciones eliminadas",
    manage_deleteLocations_are_in_use: "No es posible eliminar ubicaciones en uso",
}